import { jsx as _jsx } from "react/jsx-runtime";
import UIImage from 'UIComponents/image/UIImage';
import imageUrls from '../images/imageUrls';
import { getIsMobile } from '../utils/deviceUtils';
export const ChatSpotLogo = () => {
  const isMobile = getIsMobile();
  const url = isMobile ? imageUrls.chatSpotMobileLogo : imageUrls.chatSpotLogo;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(UIImage, {
      alt: "ChatSpot",
      height: 55,
      responsive: false,
      src: url
    })
  });
};